import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import MarketSnapshotsDataPreferences from 'lumen/components/market/snapshots/data-preferences';
import MarketSnapshotsPage from 'lumen/components/market/snapshots/page';
import MarketSnapshotsTableLayout from 'lumen/components/market/snapshots/table-layout';
import type MarketSnapshotsForecastController from 'lumen/controllers/market/snapshots/forecast';
import type MarketSnapshotsForecastRoute from 'lumen/routes/market/snapshots/forecast';
import type { ModelFrom } from 'lumen/utils/routes';

interface MarketSnapshotsForecastSignature {
  Args: {
    controller: MarketSnapshotsForecastController;
    model: ModelFrom<MarketSnapshotsForecastRoute>;
  };
}

<template>
  <MarketSnapshotsPage
    @dates={{@controller.dates}}
    @kpiSection={{@controller.kpiSection}}
    @pagination={{@controller.pagination}}
    @table={{@controller.table}}
    @title={{t "market.snapshots.view.forecast"}}
    @view="forecast"
  >
    <:controls>
      <MarketSnapshotsDataPreferences
        @dataPreferences={{@controller.dataPreferences}}
        @onSave={{@controller.updateDataPreferences}}
        @showForecastColumn={{false}}
        @showSdlyColumn={{false}}
        class="ms-auto"
      />
    </:controls>

    <:tableControls>
      <MarketSnapshotsTableLayout
        @manageColumns={{hash
          fixed=@controller.config.columns.fixed
          kpiSettings=@controller.kpiColumnSettings
          metrics=@controller.columnMetrics
          settings=@controller.columnSettings
        }}
        @onSave={{@controller.updateTableLayoutPreferences}}
        @tableLayoutPreferences={{@controller.tableLayoutPreferences}}
      />
    </:tableControls>
  </MarketSnapshotsPage>
</template> satisfies TOC<MarketSnapshotsForecastSignature>;
